import { render, staticRenderFns } from "./prestart-partial-view.vue?vue&type=template&id=f8a8d498&"
import script from "./prestart-partial-view.vue?vue&type=script&lang=js&"
export * from "./prestart-partial-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports